import routes from 'js/core_pre_webpack/routes';
import fetchWithCsrf from 'js/utils/fetch_with_csrf';

export type UnreadCountResponse = {
  count: number;
};

export async function getUnreadCount(): Promise<UnreadCountResponse> {
  const response = await fetchWithCsrf(
    routes.unread_count_api_v0_notification_messages_path({
      subdomain_param: 'api',
    }),
  );

  if (response.status !== 200) {
    throw new Error(`Unable to fetch unread notifications count.`);
  }

  return await response.json();
}
